<template>
  <PageLayout
    class="work-home"
    :class="homeThemeClass"
    :leftArrow="false"
    langChooseLocation="left"
    navBarSlot="right"
    :clickLeft="() => {}"
    :showNavBar="false"
  >
    <!-- <template #right>
      <p
        class="work-home-history-btn"
        @click="goToPage('list', 'clickHomeTopGoOrderList')"
      >
        <van-badge :dot="hasRedDot">
          <van-icon
            name="underway-o"
            size="15"
            class="work-home-history-btn-ico"
          />{{ languages.mylist_headerTitle }}
        </van-badge>
      </p>
    </template>
    <div class="work-home-wrap">
      <faq-notice-bar :source="locationType.homePage"></faq-notice-bar>
      <template v-if="faqSiteName && hasFaqClassList">
        <section-title :title="languages.smartOrderNeedHelp"></section-title>
        <van-form class="work-home-search">
          <van-search
            class="search"
            :placeholder="languages.smartOrderInputQuestion"
            background="transparent"
            @click="goToPage('workSearch', 'clickHomeGoSearch')"
          >
            <template #left-icon>
              <div></div>
            </template>
            <template #right-icon>
              <van-icon name="search" class="search-ico" />
            </template>
          </van-search>
        </van-form>
      </template>
      <section-title
        :title="languages.smartOrderCreate"
        v-show="hasWorkTempList && !isJumpAiBot"
      ></section-title>
      <work-temp-list
        v-show="hasWorkTempList && !isJumpAiBot"
        :source="locationType.homePage"
      ></work-temp-list>
      <template v-if="hasFaqClassList || (isLogin && isJumpAiBot)">
        <section-title :title="languages.smartOrderLookHelpTip"></section-title>
        <div class="work-home-faq">
          <div
            class="work-home-faq-item"
            v-for="item in faqClassList"
            :key="item.id"
            @click="goToFaqList(item.id)"
          >
            <img
              :src="item.icon"
              class="work-home-faq-item-ico"
              v-if="item.icon"
            />
            <em class="icon iconfont icon-box" v-else></em>
            <div class="work-home-faq-item-text">
              <p class="van-ellipsis">{{ item.text }}</p>
              <van-icon name="arrow" size="16" class="icon" />
            </div>
          </div>
          <div
            class="work-home-faq-item"
            @click="contactService"
            v-if="isLogin && isJumpAiBot"
          >
            <em class="icon iconfont icon-service"></em>
            <div class="work-home-faq-item-text">
              <p class="van-ellipsis">
                {{ languages.smartOrderContactService }}
              </p>
              <van-icon name="arrow" size="16" class="icon" />
            </div>
            <span class="beta">BETA</span>
          </div>
        </div>
      </template>
    </div> -->
    <div class="work-home-content-box">
      <div class="work-home-top">
        <div class="work-home-title-block">
          <div class="work-home-title-content">
            <span v-if="gameName" class="work-home-game-name">
              {{ gameName ? '&lt;' + gameName + '&gt;' : '' }}
            </span>
            <span class="work-home-title">
              {{ languages.workHomeTitle }}
            </span>
          </div>
        </div>
        <div class="lang-choose">
          <Select
            class="lang-choose-select"
            v-model="langChooseValue"
            @change="changeLang"
          >
            <option
              v-for="(text, langVal) in realLangList"
              :key="langVal"
              :value="langVal"
            >
              {{ text }}
            </option>
          </Select>
        </div>
      </div>
      <div
        class="work-home-banner work-home-banner-swiper-container swiper-container"
        v-if="workHomeBannerList.length > 0"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in workHomeBannerList"
            :key="index"
          >
            <img :src="item.img" class="slide-img" alt="banner-img" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="work-home-bottom">
        <div class="work-home-content-left">
          <template v-if="showFaq && faqSiteName && hasFaqClassList">
            <van-form class="work-home-search">
              <van-search
                class="search"
                :placeholder="languages.workHomeSearchPlaceholder"
                @click="goToPage('workSearch', 'clickHomeGoSearch')"
              >
                <template #left-icon>
                  <div></div>
                </template>
                <template #right-icon>
                  <van-icon name="search" class="search-ico" />
                </template>
              </van-search>
            </van-form>
          </template>
          <template v-if="showFaq && hasFaqClassList">
            <div class="work-home-faq">
              <div
                class="work-home-faq-item"
                v-for="item in faqClassList"
                :key="item.id"
                :class="{
                  'work-home-faq-item-unfold': isHomeFaqExpanded(item.id)
                }"
              >
                <div
                  class="work-home-faq-item-text"
                  @click="toggleHomeFaq(item)"
                >
                  <p class="van-ellipsis">{{ item.text }}</p>
                  <span class="work-home-faq-arrow"></span>
                </div>
                <div
                  class="work-home-faq-detail"
                  v-if="isHomeFaqExpanded(item.id)"
                >
                  <template v-if="item.sub && item.sub.length">
                    <div
                      class="work-home-faq-group"
                      v-for="sub in item.sub"
                      :key="sub.id"
                    >
                      <p class="work-home-faq-group-title">
                        {{ sub.text }}
                      </p>
                      <template
                        v-if="
                          homeFaqArticleList[sub.id] &&
                          homeFaqArticleList[sub.id].length > 0
                        "
                      >
                        <p
                          class="work-home-faq-article"
                          v-for="article in homeFaqArticleList[sub.id]"
                          :key="article.ID"
                          @click="goToHomeFaqDetail(article.ID)"
                        >
                          <span class="van-ellipsis">{{ article.TITLE }}</span>
                          <van-icon name="arrow" size="16" class="icon" />
                        </p>
                      </template>
                      <p v-else class="work-home-faq-empty">
                        {{
                          homeFaqLoadingMap[item.id]
                            ? 'Loading'
                            : languages.smartOrderComing
                        }}
                      </p>
                    </div>
                  </template>
                  <p v-else class="work-home-faq-empty">
                    {{ languages.smartOrderComing }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="work-home-content-right">
          <template v-if="showFaq && faqSiteName && hasFaqClassList">
            <van-form class="work-home-search">
              <van-search
                class="search"
                :placeholder="languages.workHomeSearchPlaceholder"
                @click="goToPage('workSearch', 'clickHomeGoSearch')"
              >
                <template #left-icon>
                  <div></div>
                </template>
                <template #right-icon>
                  <van-icon name="search" class="search-ico" />
                </template>
              </van-search>
            </van-form>
          </template>
          <div class="user-info-box">
            <div class="user-info-top">
              <div class="user-avatar"></div>
              <div class="user-info">
                <p class="user-name">{{ loginAccount }}</p>
                <p class="user-uid">UID: {{ uid }}</p>
              </div>
              <div
                class="work-home-history-btn"
                @click="goToPage('list', 'clickHomeTopGoOrderList')"
              >
                <van-badge :dot="hasRedDot">
                  {{ languages.mylist_headerTitle }}
                </van-badge>
              </div>
            </div>
            <div v-if="userInfo.serverName" class="user-sever-box">
              <div class="user-sever-label">
                {{ languages.workHomeCurServer }}
              </div>
              <div class="user-sever-name">
                {{ userInfo.serverName || '' }}
              </div>
            </div>
          </div>
          <div v-if="showSelfService" class="self-service-box">
            <div class="self-service-title">
              {{ languages.workHomeSelfService }}
            </div>
            <div class="self-service-btn-list">
              <div
                v-for="item in selfServiceItems"
                :key="(item.source || '') + '-' + (item.id || item.key || '')"
                class="self-service-btn-item"
                @click="onSelfServiceClick(item)"
              >
                <SelfServiceBtnText :text="item.name || ''" />
              </div>
            </div>
          </div>
          <div
            v-if="showServiceEntrance"
            class="service-entrance-box"
            :class="{ 'is-dual': showDualServiceEntrance }"
          >
            <!-- 双开左右：智能左、人工右；单开仍用 big 大卡全宽 -->
            <div
              v-if="showAiServiceEntrance"
              class="ai-service-entrance"
              :class="{ big: !showDualServiceEntrance }"
              @click.stop="contactAiService"
            >
              <div class="ai-service-entrance-icon"></div>
              <div class="ai-service-entrance-title">
                <SelfServiceBtnText
                  v-if="showDualServiceEntrance"
                  :text="languages.workHomeAiService"
                />
                <template v-else>
                  {{ languages.workHomeAiService }}
                </template>
              </div>
              <div class="ai-service-entrance-btn">
                <SelfServiceBtnText
                  v-if="showDualServiceEntrance"
                  :text="languages.workHomeServiceEntrance"
                />
                <template v-else>
                  {{ languages.workHomeServiceEntrance }}
                </template>
              </div>
            </div>
            <div
              v-if="showManualServiceEntrance"
              class="artificial-service-entrance"
              :class="{ big: !showDualServiceEntrance }"
              @click.stop="contactManualService"
            >
              <div class="artificial-service-entrance-icon"></div>
              <div class="artificial-service-entrance-title">
                <SelfServiceBtnText
                  v-if="showDualServiceEntrance"
                  :text="languages.workHomeArtificialService"
                />
                <template v-else>
                  {{ languages.workHomeArtificialService }}
                </template>
              </div>
              <div class="artificial-service-entrance-btn">
                <SelfServiceBtnText
                  v-if="showDualServiceEntrance"
                  :text="languages.workHomeServiceEntrance"
                />
                <template v-else>
                  {{ languages.workHomeServiceEntrance }}
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <ContactServerBtn
      class="service-btn"
      :customClick="contactService"
      v-if="isLogin && isJumpAiBot"
    ></ContactServerBtn> -->
    <NoticePopup
      v-bind:visible.sync="isNoticePopup"
      :languages="languages"
      :noticeList="noticeList"
      @closePopup="isNoticePopup = false"
    ></NoticePopup>
    <AiBotPopup
      v-bind:visible.sync="showAiBotPopup"
      :aiBotLink="aiBotLink"
    ></AiBotPopup>
  </PageLayout>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Swiper from 'swiper';
import PageLayout from '@components/officialSupport/common/PageLayout.vue';
import SectionTitle from '@components/officialSupport/common/SectionTitle.vue';
import Select from '@components/officialSupport/common/Select.vue';
import WorkTempList from '@components/officialSupport/WorkTempList.vue';
import NoticePopup from '@components/officialSupport/NoticePopup.vue';
import FaqNoticeBar from '@components/officialSupport/FaqNoticeBar.vue';
import AiBotPopup from '@components/officialSupport/AiBotPopup.vue';
import SelfServiceBtnText from '@components/officialSupport/SelfServiceBtnText.vue';
import globalConfig from '@utiles/globalConfig';
import {
  clickButton,
  locationType,
  showPopup
} from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import ContactServerBtn from '@components/officialSupport/ContactServerBtn.vue';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import aiBot from '@mixins/officialSupport/aiBot';
import { SET_LANG, SET_IS_SPECIAL_DIFY_USER } from '@store/officialSupport';
import { getSupportThemeClass } from '@utiles/officialSupport/theme';
import { buildWorkTempQuery } from '@utiles/officialSupport';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
let from = globalConfig.getHrefParam('from');
const isAi = globalConfig.getHrefParam('ai') == '1';
const mainHost = globalConfig.getMainHost();
export default {
  name: 'WorkHome',
  mixins: [pointStayTime, iframeMessage, aiBot],
  data() {
    return {
      openNoticePopup: false, // 是否开启客服公告弹框
      hasShowedNoticePopup: false, // 是否弹过，弹过一次之后不再弹，刷新页面重新请求接口
      isNoticePopup: false,
      noticeList: [],
      isExeUserCenter: ['pnsClient', 'exeClient'].includes(from), // 是否是微端打开
      isExe: globalConfig.getHrefParam('device') == 'exe',
      gameId:
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id') ||
        '',
      serverId:
        globalConfig.getHrefParam('serverId') ||
        globalConfig.getHrefParam('server_id') ||
        '',
      locationType,
      hasRedDot: false,
      // showAiBtn: isAi,
      showAiBotPopup: false,
      langChooseValue: '',
      homeFaqActiveIds: [],
      homeFaqArticleList: {},
      homeFaqLoadingMap: {},
      homeFaqToggleLockMap: {}
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.mylist,
      curLang: state => state.curLang,
      langList: state => state.langList,
      supportLang: state => state.supportLang,
      faqSiteName: state => state.faqSiteName,
      faqClassList: state => state.faqClassList,
      workTempList: state => state.workTempList,
      selfServiceItems: state => state.selfServiceItems,
      uid: state => state.uid,
      loginAccount: state => state.loginAccount,
      gameName: state => state.gameName,
      userInfo: state => state.userInfo,
      isLogin: state => state.isLogin
    }),
    ...mapGetters([
      'hasFaqClassList',
      'hasWorkTempList',
      'showSelfService',
      'showAiServiceEntrance',
      'showManualServiceEntrance',
      'showServiceEntrance',
      'showFaq'
    ]),
    // 主题挂在组件自身，路由离开时不依赖父级 class，避免过渡闪帧
    homeThemeClass() {
      return getSupportThemeClass(this.gameId);
    },
    showDualServiceEntrance() {
      return this.showAiServiceEntrance && this.showManualServiceEntrance;
    },
    realLangList() {
      return Object.keys(this.supportLang).length > 0
        ? this.supportLang
        : this.langList;
    },
    workHomeBannerList() {
      if (this.gameId == 456 || this.gameId == 386) {
        return [
          {
            img: require('@assets/image/officialSupport/roworld/banner.webp'),
            link: ''
          },
        ];
      }
      return [];
    },
  },
  watch: {
    $route: {
      handler(newRoute, oldRoute) {
        if (newRoute?.name == 'workhome') {
          this.checkHasNewReply();
        }
      },
      deep: true
    },
    curLang(val, oldVal) {
      this.langChooseValue = val;
      if (val != oldVal) {
        this.homeFaqActiveIds = [];
        this.homeFaqArticleList = {};
        this.homeFaqLoadingMap = {};
        this.homeFaqToggleLockMap = {};
        this.getFaqClassList(true);
        this.getWorkTempList(true);
        this.getHomeConfig();
        this.getFaqNotice();
        // 自动展开前两个faq
        this.faqClassList.slice(0, 2).forEach(item => this.toggleHomeFaq(item));
      }
    }
  },
  async created() {
    this.getNoticePopup().then(() => {
      this.checkShowNoticePopup();
    });
    this.checkHasNewReply();
  },
  mounted() {
    this.$nextTick(() => {
      this.langChooseValue = this.curLang;
      this.initSwiper();
      // 自动展开前两个faq
      this.faqClassList.slice(0, 2).forEach(item => this.toggleHomeFaq(item));
    });
  },
  methods: {
    ...mapActions([
      'getFaqClassArticleList',
      'getFaqClassList',
      'getWorkTempList',
      'getHomeConfig',
      'getFaqNotice',
      'getNoticePopupConfig',
      'postShowNoticeRecord',
      'getWorkList'
    ]),
    changeLang(value) {
      this.$store.commit(SET_LANG, value);
      clickButton({
        btnName: 'clickChooseLang',
        otherParams: {
          lang: value
        }
      });
    },
    onSelfServiceClick(item) {
      const source = String(item?.source || '').toLowerCase();
      if (source === 'form' && item?.id) {
        this.$router.push({
          name: 'selfserviceform',
          query: {
            formId: item.id,
            name: item.name || ''
          }
        });
        return;
      }
      if (source === 'fixed' && item?.key) {
        this.$router.push({
          name: 'selfService',
          query: {
            type: item.key,
            name: item.name || ''
          }
        });
        return;
      }
      this.$toast(this.languages.smartOrderComing);
    },
    goTemp(item) {
      const { id, fixedProcessType } = item;
      clickButton({
        btnName: 'clickGoSmartOrder',
        locationKey: locationType.homePage || '',
        otherParams: {
          workTempId: id
        }
      });
      if (+fixedProcessType === 1) {
        this.$router.push({
          name: 'accountdelete',
          query: {
            workTempId: id,
            source: locationType.homePage || ''
          }
        });
        return;
      }
      this.$router.push({
        name: 'worktemp',
        query: buildWorkTempQuery({
          workTempId: id,
          source: locationType.homePage || ''
        })
      });
    },
    isHomeFaqExpanded(id) {
      return this.homeFaqActiveIds.includes(id);
    },
    async toggleHomeFaq(item) {
      const now = Date.now();
      const lastToggleAt = this.homeFaqToggleLockMap[item.id] || 0;
      // 300ms 内忽略同项二次切换，避免连点展开/收起互相抵消
      if (now - lastToggleAt < 300) {
        return;
      }
      this.$set(this.homeFaqToggleLockMap, item.id, now);
      clickButton({
        btnName: 'clickFaqFirstClass',
        locationKey: locationType.homePage,
        otherParams: {
          faqClassId: item.id
        }
      });
      const activeIndex = this.homeFaqActiveIds.indexOf(item.id);
      if (activeIndex !== -1) {
        this.homeFaqActiveIds.splice(activeIndex, 1);
        return;
      }
      this.homeFaqActiveIds.push(item.id);
      await this.loadHomeFaqArticleList(item);
    },
    async loadHomeFaqArticleList(item) {
      const subList = item.sub || [];
      if (!subList.length || this.homeFaqLoadingMap[item.id]) return;
      this.$set(this.homeFaqLoadingMap, item.id, true);
      try {
        await Promise.all(
          subList.map(async sub => {
            if (this.homeFaqArticleList[sub.id]) return;
            const data = await this.getFaqClassArticleList({
              classId: sub.id
            });
            this.$set(this.homeFaqArticleList, sub.id, data);
          })
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.$set(this.homeFaqLoadingMap, item.id, false);
      }
    },
    goToHomeFaqDetail(faqId) {
      clickButton({
        btnName: 'goFaqDetail',
        locationKey: locationType.homePage,
        otherParams: {
          faqId
        }
      });
      this.$router.push({
        name: 'workfaqdetail',
        query: {
          faqId
        }
      });
    },
    goToFaqList(id) {
      clickButton({
        btnName: 'clickFaqFirstClass',
        locationKey: locationType.homePage,
        otherParams: {
          faqClassId: id
        }
      });
      this.$router.push({
        path: '/workfaqlist',
        query: {
          firstClassId: id
        }
      });
    },
    goToPage(name, pointEventName) {
      const pageName = {
        list: 'mylist',
        workSearch: 'worksearch'
      };
      if (pointEventName) {
        clickButton({
          btnName: pointEventName,
          locationKey: locationType.homePage
        });
      }
      pageName[name] && this.$router.push(`/${pageName[name]}`);
    },
    checkShowNoticePopup() {
      if (this.openNoticePopup && !this.hasShowedNoticePopup) {
        this.isNoticePopup = true;
        this.hasShowedNoticePopup = true;
        this.sendShowNoticeRecord();
        showPopup(locationType.noticePopup);
      }
    },
    sendShowNoticeRecord() {
      this.postShowNoticeRecord({
        announcement_id: this.noticeList.map(item => item.id).join(',')
      });
    },
    getNoticePopup() {
      return new Promise(async resolve => {
        let newDevicePlate = globalConfig.getHrefParam('devicePlate');
        const devicePlate = globalConfig.getHrefParam('devicePlate');
        if (['pc', 'h5'].includes(devicePlate)) {
          if (this.isExeUserCenter || this.isExe) {
            newDevicePlate = 'pc';
          } else {
            newDevicePlate = 'h5';
          }
        }
        try {
          const data = await this.getNoticePopupConfig({
            game_id: this.gameId,
            server_id: this.serverId,
            devicePlate: newDevicePlate,
            zone: this.curLang
          });
          if (data?.has_announce) {
            this.openNoticePopup = true;
            this.noticeList = data?.announcement || [];
            resolve();
          } else {
            resolve();
          }
        } catch (error) {
          resolve();
        }
      });
    },
    async checkHasNewReply() {
      const data = await this.getWorkList({
        is_check_unread: true
      });
      this.hasRedDot = +data?.UNREAD_COUNT > 0 || false;
    },
    /** 首页客服入口是否改跳官方在线客服（按游戏+区服等特殊规则） */
    isJumpOnlineSupport() {
      // 295 且 serverId>1000084
      if (this.gameId == 295 && Number(this.serverId) > 1000084) {
        return true;
      }
      return false;
    },
    contactService() {
      const jumpOnlineSupport = this.isJumpOnlineSupport();

      clickButton({
        btnName: 'clickContactService',
        locationKey: locationType.homePage,
        otherParams: {
          frontVersion: `v1_${new Date().getTime()}`,
          isOpenAiEntrance: this.isJumpAiBot,
          isLogin: this.isLogin,
          isJumpOnlineSupport: jumpOnlineSupport
        }
      });

      if (jumpOnlineSupport) {
        const params = new URLSearchParams(window.location.search || '');
        params.set('from', 'officialSupport');
        // 语言切换后以当前页语言为准，覆盖 URL 中的 language / appLanguage
        if (this.curLang) {
          params.set('language', this.curLang);
          params.set('appLanguage', this.curLang);
        }
        window.location.href = getGlobalGetGotoLink({
          link: `https://help.${mainHost}/online_support/index.html?${params.toString()}`
        });
        return;
      }

      this.handleContactService('homeBtn');
    },
    contactAiService() {
      clickButton({
        btnName: 'clickContactService',
        locationKey: locationType.homePage,
        otherParams: {
          frontVersion: `v1_${new Date().getTime()}`,
          isOpenAiEntrance: true,
          isLogin: this.isLogin,
          entrance: 'ai'
        }
      });
      if (
        this.isLogin &&
        !globalConfig.isTiktokMiniProgram()
      ) {
        this.goAiBot();
        return;
      }
      this.$store.commit(SET_IS_SPECIAL_DIFY_USER, 0);
      this.goCreateCommerOrder('homeBtn');
    },
    contactManualService() {
      clickButton({
        btnName: 'clickContactService',
        locationKey: locationType.homePage,
        otherParams: {
          frontVersion: `v1_${new Date().getTime()}`,
          isOpenAiEntrance: false,
          isLogin: this.isLogin,
          entrance: 'manual'
        }
      });
      this.$store.commit(SET_IS_SPECIAL_DIFY_USER, 0);
      this.goCreateCommerOrder('homeBtn');
    },
    initSwiper() {
      try {
        new Swiper('.work-home-banner-swiper-container', {
          loop: true,
          autoplay:
            this.workHomeBannerList.length > 1
              ? {
                  delay: 4000,
                  stopOnLastSlide: false,
                  disableOnInteraction: false
                }
              : false,
          direction: 'horizontal',
          pagination: {
            el: '.swiper-pagination'
          },
          effect: 'slide',
          observer: true,
          observeParents: true
        });
      } catch (e) {
        console.log(e);
      }
    }
  },
  components: {
    Select,
    PageLayout,
    SectionTitle,
    WorkTempList,
    NoticePopup,
    FaqNoticeBar,
    ContactServerBtn,
    AiBotPopup,
    SelfServiceBtnText
  }
};
</script>

<style lang="scss" scoped>
// .work-home {
//   &-wrap {
//     padding: 0 10px;
//     box-sizing: border-box;
//   }
//   &-history-btn {
//     display: flex;
//     align-items: center;
//     color: var(--text-color);
//     font-size: 14px;
//     &-ico {
//       margin-right: 5px;
//       color: var(--text-color) !important;
//     }
//   }
//   &-search {
//     z-index: 2;
//     background-color: var(--page-bgColor);
//     ::v-deep .van-field__clear {
//       padding: 0 8px 0 16px !important;
//     }
//     .search {
//       overflow: hidden;
//       width: 100%;
//       padding: 0;
//       margin: 0 auto 26px;
//       border-radius: 8px;

//       ::v-deep .van-field__control {
//         color: var(--text-color);
//         caret-color: transparent;

//         &::after {
//           display: none;
//         }
//       }

//       ::v-deep .van-field {
//         line-height: 34px;
//       }
//       ::v-deep .van-icon-search {
//         font-size: 24px;
//         font-weight: bold;
//         color: #767676;
//       }
//       ::v-deep .van-search__content {
//         background-color: var(--block-bg-light-color);
//         border-radius: 8px;
//         padding-left: 10px;
//       }
//     }
//   }
//   &-faq {
//     display: grid;
//     grid-template-columns: repeat(2, minmax(0, 1fr)); /* 防止内容溢出 */
//     grid-auto-rows: auto; /* 多行 */
//     grid-gap: 16px; /* 列中间间隔随意 */
//     justify-content: space-between; /* 列靠边对齐 */
//     width: 100%;
//     margin: 0 auto 16px;
//     &-item {
//       position: relative;
//       display: flex;
//       flex-direction: column;
//       justify-content: space-between;
//       padding: 20px;
//       width: 187px;
//       max-width: 100%; // 最大宽度为网格宽度，防止内容溢出
//       height: 120px;
//       border-radius: 20px;
//       box-sizing: border-box;
//       background-color: var(--block-bg-light-color);
//       cursor: pointer;
//       &-ico {
//         color: var(--main-color);
//         width: 40px;
//       }
//       &-text {
//         display: flex;
//         justify-content: space-between;
//         font-size: 16px;
//         font-weight: 500;
//         .icon {
//           display: block;
//           font-size: 16px;
//           color: var(--back-color);
//         }
//       }
//     }
//     .beta {
//       position: absolute;
//       top: 20px;
//       right: 20px;
//       color: var(--main-color);
//       line-height: 18px;
//       font-weight: 500;
//       font-size: 10px;
//       padding-left: 4px;
//       padding-right: 4px;
//       border-radius: 5px;
//       border: 1px solid var(--main-color);
//     }
//   }
//   .icon {
//     font-size: 40px;
//     color: var(--main-color);
//   }
//   .service-btn {
//     display: block;
//     position: relative;
//     bottom: unset;
//     right: unset;
//   }
// }
// // 横屏兼容
// @media screen and (orientation: landscape) {
//   .work-home-faq {
//     display: flex;
//     flex-wrap: wrap;
//     justify-content: flex-start;
//     &-item {
//       width: 200px;
//     }
//   }
// }
</style>
<style lang="scss">
.work-home {
  .swiper-pagination-bullet {
    width: 1.3889vh; // 15 / 1080 * 100 = 1.3889vh
    height: 1.3889vh; // 15 / 1080 * 100 = 1.3889vh
    background: url('~@assets/image/officialSupport/bullet.png') no-repeat center/contain;
    opacity: 1;
    margin: 0 0.463vh; // 5 / 1080 * 100 = 0.4630vh
  }
  .swiper-pagination-bullet-active {
    background: url('~@assets/image/officialSupport/bullet-active.png') no-repeat center/contain;
  }
}
</style>
